// @ts-ignore
/* eslint-disable */
import isMiniProgramUserAgent from "@Utils/isMiniProgramUserAgent";

export function initWeChatBridge(req: any, staticContext: any) {
  const isWeChatMiniProgram = isMiniProgramUserAgent(req);

  if (isWeChatMiniProgram) {
    const miniProgramToken = req.query.miniProgramToken;

    if (miniProgramToken) {
      staticContext.cookie = {
        key: "user_auth_token",
        value: miniProgramToken,
      };
      return miniProgramToken;
    }
  }
  return null;
}

export function weChatUserData(req: any) {
  const isWeChatMiniProgram = isMiniProgramUserAgent(req);

  if (isWeChatMiniProgram) {
    const userNickName = req.query.miniProgramUser;
    const userAvatarUrl = req.query.miniProgramAvatar;
    const clientId = req.query.clientId;
    const sessionId = req.query.sessionId;
    return { userNickName, userAvatarUrl, clientId, sessionId };
  }
  return null;
}

export function isWeChatAuthenticated() {
  if (typeof window === "undefined") return false;
  return !!localStorage.getItem("userToken");
}
